import { keyframes } from "styled-components";

export const featureAnimation = keyframes`
  0% { background-color: rgba(235, 194, 0, 0) }
  5% { background-color: rgba(235, 194, 0, .25) }
  50% { background-color: rgba(235, 194, 0, .15) }
  100% { background-color: rgba(235, 194, 0, 0) }
`;
